const MemoriqueIconGold = ({ width = "200px" }: { width?: string }) => {
  return (
    <img width={width} src="https://memorique-images.s3.us-east-2.amazonaws.com/images/79f228b8-8ca6-4041-877d-633100f64569.png" alt="Memorique Gold Icon" />
  );
};

export default MemoriqueIconGold;
